import { render, staticRenderFns } from "./SupplierStockTemplatePlatformMappingsComponent.vue?vue&type=template&id=788a129b&"
import script from "./SupplierStockTemplatePlatformMappingsComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockTemplatePlatformMappingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports